module.exports = __webpack_public_path__ + "img/logo-tw-white.3074a656.svg";